<div class="admin-warning" [class.error]="'error' === type" [class.warning]="'warning' === type">
    <mat-icon aria-hidden="false" aria-label="Warning icon" color="warn">error</mat-icon>
    {{ message }}
</div>